module.exports = __webpack_public_path__ + "static/media/redo.7716c581.svg";